'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableCellLayout", {
    enumerable: true,
    get: function() {
        return TableCellLayout;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableCellLayout = require("./useTableCellLayout");
const _renderTableCellLayout = require("./renderTableCellLayout");
const _useTableCellLayoutStylesstyles = require("./useTableCellLayoutStyles.styles");
const _useTableCellLayoutContextValues = require("./useTableCellLayoutContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableCellLayout = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableCellLayout.useTableCellLayout_unstable)(props, ref);
    (0, _useTableCellLayoutStylesstyles.useTableCellLayoutStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableCellLayoutStyles_unstable')(state);
    return (0, _renderTableCellLayout.renderTableCellLayout_unstable)(state, (0, _useTableCellLayoutContextValues.useTableCellLayoutContextValues_unstable)(state));
});
TableCellLayout.displayName = 'TableCellLayout';
